import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submitButton", "ccLine", "ccEmails"]

  connect() {
    console.log("Support ticket form controller connected")
  }

  pharmacyChanged(event) {
    const option = event.target.selectedOptions[0]
    const cc = (option && option.dataset.cc) ? option.dataset.cc.trim() : ""

    if (!this.hasCcLineTarget || !this.hasCcEmailsTarget) return

    if (cc.length === 0) {
      this.ccLineTarget.classList.add("hidden")
    } else {
      this.ccLineTarget.classList.remove("hidden")
      this.ccEmailsTarget.textContent = cc
    }
  }

  async submit(event) {
    event.preventDefault()

    const formData = new FormData(this.formTarget)
    const description = formData.get("support_ticket[description]")

    if (!description || description.trim() === "") {
      alert("Please enter a description for your support ticket")
      return
    }

    try {
      this.disableSubmitButton()

      const response = await fetch(this.formTarget.action, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
          "Accept": "application/json"
        },
        body: formData
      })

      const data = await response.json()

      if (response.ok) {
        // Redirect to the ticket show page
        window.location.href = `/support_tickets/${data.ticket.id}`
      } else {
        alert(data.error || "Failed to create support ticket")
        this.enableSubmitButton()
      }
    } catch (error) {
      console.error("Error creating support ticket:", error)
      alert("An error occurred while creating the support ticket")
      this.enableSubmitButton()
    }
  }

  disableSubmitButton() {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    this.submitButtonTarget.textContent = "Creating..."
  }

  enableSubmitButton() {
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    this.submitButtonTarget.innerHTML = `
      <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
      </svg>
      Submit
    `
  }
}
